import { forwardRef, useState } from "react";

export interface ButtonBaseProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    ariaLabel?: string;
    isSelected?: boolean;
    renderContent: (isHovered: boolean) => React.ReactNode;
}

export const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(function ButtonBase({
    ariaLabel,
    isSelected = false,
    renderContent,
    onClick,
    onKeyDown,
    type = "button",
    className = "",
    ...props
},
    ref
) {
    const [isHovered, setIsHovered] = useState(false);
    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        onKeyDown?.(e);
        if (e.defaultPrevented) return;

        const isEnter = e.key === "Enter";
        const isSpace = e.key === " " || e.code === "Space" || e.key === "Spacebar";
        if (isEnter || isSpace) {
            e.preventDefault();
            (e.currentTarget as HTMLButtonElement).click();
        }
    };

    return (
        <button
            ref={ref}
            type={type}
            aria-pressed={isSelected || undefined}
            aria-label={ariaLabel}
            className={`${className} ${isSelected ? "selected" : ""}`.trim()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onFocus={() => setIsHovered(true)}
            onBlur={() => setIsHovered(false)}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            {...props}
        >
            {renderContent(isHovered)}
        </button>
    );   
});

ButtonBase.displayName = "ButtonBase";

export default ButtonBase;